import { assetTransferPages } from './assetTransferPages';

export default {
  title: 'Asset transfers',
  pages: assetTransferPages,
};
